export default {"src":"/_next/static/media/family_24.856b5abf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};